module.exports = __webpack_public_path__ + "static/img/Luke_Shuey_desktop.c478ff0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Luke_Shuey_desktop.jpg
// module id = t6Nj
// module chunks = 0